<template>
  <div
    v-if="questions.length"
    class="container mx-auto mt-10 md:mt-12 lg:mt-16 xl:mt-20 lg:px-0 px-4 mb-24"
  >
    <h2
      class="text-center mx-auto max-w-6xl text-2xl sm:text-3xl lg:text-4xl font-semibold"
      :class="{ 'font-inter': locale == 'vi' }"
    >
      {{ dataLocale.data.title }}
    </h2>
    <div class="mt-4 md:mt-6 text-center lg:mt-8 text-base sm:text-lg">
      {{ dataLocale.data.description }} "{{ topic }}"
    </div>
    <div class="lg:mt-24 mt-12">
      <div class="grid grid-cols-12 md:gap-8 gap-y-8">
        <div
          class="col-span-12 md:col-span-6 h-full flex justify-center"
          v-for="question in questions"
        >
          <div class="flex gap-4">
            <div
              class="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-md border border-gray-200"
            >
              <QuestionMarkIcon size="20" />
            </div>
            <div class="flex flex-col">
              <h3 class="font-semibold md:text-xl text-lg mb-2">
                {{ question.question }}
              </h3>
              <p>
                {{ question.answer }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-10 flex items-center justify-center">
      <a
        href="https://app.qrdove.com"
        target="_blank"
        class="flex items-center gap-2 h-[50px] px-8 rounded-md bg-success text-white drop-shadow-md hover:drop-shadow-xl"
      >
        {{ $t("sign_up") }} & {{ $t("try_free_now") }}</a
      >
    </div>
  </div>
</template>
<script lang="ts" setup>
import { QuestionMarkIcon, CertificateIcon } from "vue-tabler-icons";
import DataLocale from "~~/config/interface/DataLocale";
interface Question {
  question: string;
  answer: string;
  icon?: string;
}
const { locale } = useI18n();
const props = defineProps({
  topic: {
    type: String,
    default: "",
  },
  questions: {
    type: Array<Question>,
    default: [],
  },
});
const dataLocale = new DataLocale([
  {
    locale: "en",
    title: "Frequently Asked Question",
    description:
      "Quick and accurate answers to frequently asked questions and concerns on the topic ",
  },
  {
    locale: "fr",
    title: "Questions fréquemment posées",
    description:
      "Réponses rapides et précises aux questions et préoccupations fréquemment posées sur le sujet ",
  },
  {
    locale: "it",
    title: "Domande frequenti",
    description:
      "Risposte rapide ed accurate alle domande e preoccupazioni frequenti sul tema ",
  },
  {
    locale: "de",
    title: "Häufig gestellte Fragen",
    description:
      "Schnelle und genaue Antworten auf häufig gestellte Fragen und Bedenken zum Thema ",
  },
  {
    locale: "es",
    title: "Preguntas frecuentes",
    description:
      "Respuestas rápidas y precisas a preguntas y preocupaciones frecuentes sobre el tema ",
  },
  {
    locale: "nl",
    title: "Veelgestelde vragen",
    description:
      "Snelle en accurate antwoorden op veelgestelde vragen en zorgen over het onderwerp ",
  },
  {
    locale: "pt",
    title: "Perguntas Frequentes",
    description:
      "Respostas rápidas e precisas para perguntas e preocupações frequentes sobre o tema ",
  },
  {
    locale: "ja",
    title: "よくある質問",
    description:
      "このトピックに関するよくある質問や懸念事項に対する迅速かつ正確な回答 ",
  },
  {
    locale: "zh",
    title: "常见问题",
    description: "针对该主题的常见问题和关注点，提供快速准确的答案 ",
  },
  {
    locale: "vi",
    title: "Câu hỏi thường gặp",
    description:
      "Câu trả lời nhanh chóng và chính xác cho các câu hỏi và vấn đề thường gặp về chủ đề ",
  },
  {
    locale: "id",
    title: "Pertanyaan yang Sering Diajukan",
    description:
      "Jawaban cepat dan akurat untuk pertanyaan dan masalah yang sering diajukan tentang topik ",
  },
  {
    locale: "tr",
    title: "Sıkça Sorulan Sorular",
    description:
      "Konuyla ilgili sık sorulan sorulara ve endişelere hızlı ve doğru yanıtlar ",
  },
  {
    locale: "hi",
    title: "अक्सर पूछे जाने वाले प्रश्न",
    description:
      "विषय पर अक्सर पूछे जाने वाले प्रश्नों और चिंताओं के त्वरित और सटीक उत्तर ",
  },
  {
    locale: "th",
    title: "คำถามที่พบบ่อย",
    description:
      "คำตอบที่รวดเร็วและแม่นยำสำหรับคำถามและข้อกังวลที่พบบ่อยเกี่ยวกับหัวข้อ ",
  },
]);
</script>
